import React from 'react';
import Modal from '../common/Modal';

const CSVUploadTipsModal = ({ show, close }) => {
  return (
    <Modal title='metadata-viewer' show={show} onClose={close}>
      <header>
        <h3>CSV Uploading Tips</h3>
      </header>
      <div className='content'>
        <div style={{ margin: '8px' }}>
          <h3>CSV Create</h3>
          <h4>Option Columns (case-insensitive):</h4>
          <hr />
          <ul style={{ marginBottom: '8px' }}>
            <li style={{ fontWeight: 'bold' }}>name (required)</li>
            <li>
              value <i>(defaults to 'name' if blank, must be unique)</i>
            </li>
            <li>
              local_quota <i>(defaults to '0' if blank)</i>
            </li>
          </ul>
          <h4>Metadata / me_ Columns (optional):</h4>
          <hr />
          <ul style={{ marginBottom: '8px' }}>
            <li>me_[Metadata_Entry_Title]</li>
            <li>
              <i>
                All metadata columns must match a Metadata Entry title with
                underscores substituted for spaces.
              </i>
            </li>
          </ul>
          <h4>Calendar / ical_ Columns (optional):</h4>
          <hr />
          <ul style={{ marginBottom: '8px' }}>
            <li style={{ fontWeight: 'bold' }}>ical_summary (required)</li>
            <li style={{ fontWeight: 'bold' }}>
              ical_description (required, max 255 chars)
            </li>
            <li style={{ fontWeight: 'bold' }}>
              ical_dtstart (required: MM/DD/YYYY hh:mm AM )
            </li>
            <li style={{ fontWeight: 'bold' }}>
              ical_dtend (required: MM/DD/YYYY hh:mm AM )
            </li>
            <li>
              ical_timezone <i>(defaults to 'America/Chicago' if blank)</i>
            </li>
            <li>ical_location</li>
            <li>ical_alert_trigger</li>
            <li>
              <i>
                Format for setting an alert trigger:
                <br /> 1-2 digits followed by D/H/M (Days/Hours/Minutes)
                <br /> Example: 7D = 7 Days prior to event
              </i>
            </li>
          </ul>
          <hr />
          <h3>CSV Update</h3>
          <h4>Columns (case-insensitive):</h4>
          <hr />
          <ul style={{ marginBottom: '8px' }}>
            <li>
              <b>Requires 'id' column.</b>
            </li>
            <li>
              <b>All other columns are optional for CSV Update.</b> You may
              provide all column data, or choose to only include columns that
              actually have values to change.
            </li>
            <li>
              Available columns include anything from the <b>CSV Create</b>{' '}
              section above.
            </li>
            <li>
              <b>
                Updates are only attempted if row has valid option 'id' value.
              </b>
            </li>
            <li>
              <b>Row values can be left blank</b> if no update for that column
              property is desired.
            </li>
            <li>
              This process does NOT create new options, but CAN create metadata
              or calendar events if values are provided.
            </li>
          </ul>
        </div>
      </div>
    </Modal>
  );
};

export default CSVUploadTipsModal;
